import styled from "styled-components";
import { ArrowScroll } from "../../../services/visualLibraryService";
import { TypedCarousel } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";


export const LayoutStyled = styled.section`
width: 100%;
top: 0;
bottom: 0;
position: absolute;
will-change: transform;
transform: ${props => `translateY(${props.position}px)`};
transition: transform 0.2s linear;
&::after {
  opacity: 0;
}
& .selected span{
  opacity:1 !important;
}
}
.focused .selected svg{
  fill:cyan !important;
}
`;

export const FiltersStyled = styled.section`
 margin-${props => `${props.direction === 'ltr' ? 'left' : 'right'}`}:6.5rem;
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  top: -${props => props.theme.spacing.large};
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s linear;
  will-change: opacity;
  display: ${props => (props.isVisible ? "block" : "none")};
`;

export const StyledPage = styled.div`
         height: 19.9rem;
         margin-left: 7.0rem;
         margin-right: 5.2rem;
        //  margin-bottom: 4rem;
        &.fixHeight h1 {
          font-size: 3.125rem !important;
          max-height: 10rem;
          overflow: hidden;
          width: 45rem;
       }
`;
export const WrapperStyled = styled.div`

`;
export const FilterCarasoulStyled = styled(TypedCarousel)`
transition: opacity 0.2s linear;
will-change: opacity;
/* TODO: Remove this when we change the carousel */
.ReactVirtualized__Grid {
  will-change: initial !important;
}
&.focused {
}

.selected .gsYuAb::before {
  // border: ${props => props.isFilterFocused ? `0.32rem solid #f1f1f1;` :  `none`} ;
}
& .Styled__ImageContainerStyled-t5q7es-1 {
  display: flex;
  justify-content: center;
  & img {
    width: ${props => (props.type === "channels" ? "auto" : "100%")};
    height: 100%;
  }
}
`;
